<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    created() {
      window.addEventListener(
        "mousewheel",
        function(event) {
          if (event.ctrlKey === true || event.metaKey) {
            event.preventDefault();
          }
        }, {
          passive: false
        }
      );

      //firefox
      window.addEventListener(
        "DOMMouseScroll",
        function(event) {
          if (event.ctrlKey === true || event.metaKey) {
            event.preventDefault();
          }
        }, {
          passive: false
        }
      );
    },
  }
</script>
